import { Container } from '@cgs/wge';
import { T_GameStateMachineNotifierComponent } from '../../type_definitions';
import {
  AbstractListener,
  GameStateMachineNotifierComponent,
} from '../components/game_state_machine_notifier_component';
import { ISlotView } from './base_slot_view';

export interface ISlotController {
  slotLoadFinished(): void;
}

export class BaseSlotController<T extends ISlotView> implements AbstractListener, ISlotController {
  private _view: T | null;
  protected _container: Container;
  private _notifierComponent: GameStateMachineNotifierComponent;

  get container(): Container {
    return this._container;
  }

  get view(): T {
    return this._view as T;
  }

  set view(value: T) {
    this._view = value;
  }

  get gameStateMachineNotifier(): GameStateMachineNotifierComponent {
    return this._notifierComponent;
  }

  constructor(container: Container, view: T | null) {
    this._container = container;
    this._view = view;
    if (this._view) {
      // HACK FOR TOTAL WIN CONTROLLER
      this._view.initController(this);
    }
    this._notifierComponent = this._container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
    this._notifierComponent.notifier.addListener(this);
  }

  onStateEntered(_slotState: string): void {}

  onStateExited(_slotState: string): void {}

  slotLoadFinished(): void {}
}
